import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, money } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Lock, ArrowUpCircle, ArrowLeft } from "lucide-react";

export default function ModuleLocked({ mod }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  useEffect(() => { setInfo(null); api.get(`/license/locked-module/${mod}`).then((r) => setInfo(r.data)).catch(() => setInfo({ label: mod, plan: null })); }, [mod]);
  const isAdmin = user?.role === "admin";
  return (
    <div className="h-full grid place-items-center fade-up" data-testid="module-locked">
      <div className="card-surface max-w-lg w-full p-8 text-center space-y-4">
        <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 grid place-items-center"><Lock className="text-amber-600" size={30} /></div>
        <h1 className="font-display text-2xl font-bold">{info?.label || "Módulo"} no está en tu plan</h1>
        {info?.plan ? (
          <p className="text-sm text-muted-foreground" data-testid="module-locked-plan">
            Este módulo está disponible en el plan <b className="text-foreground">{info.plan.name}</b>{" desde "}<b className="text-foreground">{money(info.plan.price)}</b>/{info.billing === "mensual" ? "mes" : "año"}.
            {info.current_plan && <> Tu plan actual es <b>{info.current_plan}</b>.</>}
          </p>
        ) : (
          <p className="text-sm text-muted-foreground">Este módulo no está incluido en tu licencia. Contacta a tu proveedor para habilitarlo.</p>
        )}
        <div className="flex gap-2 justify-center flex-wrap pt-2">
          <Button variant="outline" onClick={() => nav(-1)} data-testid="module-locked-back"><ArrowLeft size={15} className="mr-1" /> Regresar</Button>
          {isAdmin ? (
            <Button className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold" onClick={() => nav(info?.plan ? `/miplan?plan=${info.plan.id}` : "/miplan")} data-testid="module-locked-upgrade"><ArrowUpCircle size={16} className="mr-1" /> Subir de plan</Button>
          ) : (
            <span className="text-xs text-muted-foreground self-center">Pide al administrador del negocio que suba de plan.</span>
          )}
        </div>
      </div>
    </div>
  );
}
